/**
 * The Extensions that are always allowed for 'Safe Transfer'
 * Example: pdf, docx
 */
export const DefaultAllowedSafeTransferExtensions: string[] = ['xml', 'pdf', 'xbrl', 'xps', 'xsd', 'doc', 'docx'];


export enum PlatformSettings {

  // Auto Export
  /**
   * Whether 'Auto-Export' to Cloud/Dms is enabled
   */
  AutoExportEnabled = 'AutoExport-Enabled',
  /**
   * IF 'Auto-Export' is enabled whether the Export should be enabled for API requests
   */
  AutoExportSetForApi = 'AutoExport-ApiEnabled',
  /**
   * Default Cloud Item to export to. (Most important for API)
   */
  AutoExportCloudItem = 'AutoExport-CloudItem',


  ShowLocation = 'ShowLocation',
  ShowReason = 'ShowReason',
  UseInternalStamp = 'UseInternalStamp',
  UseExternalStamp = 'UseExternalStamp',
  UseInternalDraw = 'UseInternalDraw',
  UseExternalDraw = 'UseExternalDraw',
  UseInternalPicture = 'UseInternalPicture',
  UseExternalPicture = 'UseExternalPicture',
  OrganisationLanguage = 'OrganisationLanguage',
  EmailSender = 'EmailSender',
  ShowRecentlyContacts = 'ShowRecentlyContacts',
  SigningNote = 'SigningNote',
  EmailInviteReminderSchedule = 'EmailInviteReminderSchedule',
  EmailOwnerDocumentReminderSchedule = 'EmailOwnerDocumentReminderSchedule',
  XbrlRenderClient = 'xbrlRenderClient',
  AllowedDocumentExtensions = 'allowedDocumentExtensions',

  // Workflows
  Allow_WF_SignYourself = 'Allow_WF_SignYourself',
  Allow_WF_SignatureRequest = 'Allow_WF_SignatureRequest',
  Allow_WF_SecureFileSharing = 'Allow_WF_SecureFileSharing',
  Allow_WF_IncomeTax = 'Allow_WF_IncomeTax',
  Allow_WF_CorporateTax = 'Allow_WF_CorporateTax',
  Allow_WF_VAT = 'Allow_WF_VAT',
  Allow_WF_EUVAT = 'Allow_WF_EUVAT',
  Allow_WF_WageTax = 'Allow_WF_WageTax',
  Allow_WF_Filing = 'Allow_WF_Filing',
  Allow_WF_FilingWithReport = 'Allow_WF_FilingWithReport',
  Allow_WF_LinkingAndSigning = 'Allow_WF_LinkingAndSigning',
  Allow_WF_SbrBank = 'Allow_WF_SbrBank',
  Allow_WF_SbrBankWithReport = 'Allow_WF_SbrBankWithReport',
  Allow_WF_NoabBankAudit = 'Allow_WF_NoabBankAudit',
  Allow_WF_Wwft = 'Allow_WF_Wwft',
  Allow_WF_FilingXBRI = 'Allow_WF_FilingXBRI',
  Allow_WF_CleverbaseSignYourself = 'Allow_WF_CleverbaseSignYourself',
  Allow_WF_CleverbaseRequest = 'Allow_WF_CleverbaseRequest',


  // Email Notify settings:
  EmailOwnerDigipoortSuccesStatus = 'EmailOwnerDigipoortSuccesStatus',
  EmailOwnerDigipoortFailureStatus = 'EmailOwnerDigipoortFailureStatus',
  EmailOwnerDocumentExpires = 'EmailOwnerDocumentExpires',
  EmailOwnerSignDone = 'EmailOwnerSignDone',
  EmailOwnerSignReminder = 'EmailOwnerSignReminder',
  EmailSignerExSignReminder = 'EmailSignerExSignReminder',
  EmailSignerIDigipoortSuccesStatus = 'EmailSignerIDigipoortSuccesStatus',
  EmailSignerIDigipoortFailureStatus = 'EmailSignerIDigipoortFailureStatus',
  EmailSignerISignDone = 'EmailSignerISignDone',
  EmailSignerISignReminder = 'EmailSignerISignReminder',
  EmailOwnerSignExpired = 'EmailOwnerSignExpired',
  EmailOwnerEmailError = "EmailOwnerEmailError",
  EmailOwnerEmailExportFailure = "EmailOwnerEmailExportFailure",

  // AFAS:
  UseAFAS = 'UseAFAS',
  AfasConnectorBaseUrl = 'AfasConnectorBaseUrl',
  AfasConnectorToken = 'AfasConnectorToken',
  AfasFTP = 'AfasFTP',
  AfasFTPMultipleFilesOffered = 'AfasFTPMultipleFilesOffered',
  AfasFTPUser = 'AfasFTPUser',
  AfasFTPUserId = 'AfasFTPUserId',
  UseClientOnline = 'UseClientOnline',
  PinkwebUrl = 'PinkwebUrl',
  PinkwebUsername = 'PinkwebUsername',
  PinkwebPassword = 'PinkwebPassword',
  UseSimplicateCrmData = 'UseSimplicateCrmData',
  SimplicateApiKey = 'SimplicateApiKey',
  SimplicateApiSecret = 'SimplicateApiSecret',
  SimplicateApiSubdomain = 'SimplicateApiSubdomain',
  DigipoortEnvironment = "DigipoortEnvironment",
  SBRNexusEnvironment = "SBRNexusEnvironment",
  AansluitSuiteAanleverKenmerk = "AansluitSuiteAanleverKenmerk",

  // Services
  EnabledXbrlRenderClient = "EnabledXbrlRenderClient",
  xbrlRenderClient = "xbrlRenderClient",

  // Salesforce:
  UseSalesforceCrmData = 'UseSalesforceCrmData',
  SalesforceApiKey = 'SalesforceApiKey',
  SalesforceApiSecret = 'SalesforceApiSecret',
  SalesforceApiSubdomain = 'SalesforceApiSubdomain',

  //Identity Providers
  ValidateRealIdentity = 'ValidateRealIdentity',

  // MS Dynamics:
  Crm_UseDynamics = 'UseDynamicsCrmData',
  Crm_Dynamics_ClientId = 'MsDynamicsClientId',
  Crm_Dynamics_ClientSecret = 'MsDynamicsClientSecret',
  Crm_Dynamics_TenantId = 'MsDynamicsTenantId',
  Crm_Dynamics_SubDomain = 'MsDynamicsSubDomain',
  Crm_Dynamics_RollFilterAttribute = 'MsDynamicsRollFilterAttribute',
  Crm_Dynamics_RollFilterValue = 'MsDynamicsRollFilterValue',

  //Hyarchis
  HyarchisClientId = 'HyarchisClientId',
  HyarchisTenantId = 'HyarchisTenantId',
  HyarchisClientSecret = 'HyarchisClientSecret',
  HyarchisMaximumCount = 'HyarchisMaximumCount',
  HyarchisTenantUrl = 'HyarchisTenantUrl',
  HyarchisTenantType = 'HyarchisTenantType',
}

export enum IdentitySettings {
  KVK = 'KVK',
  GuestValidationMethod = 'GuestValidationMethod',
  CleverbaseAuthentication = 'Cleverbase_Authentication',
  CleverbaseIdentification = 'Cleverbase_Identification',
  ssorequired = 'ssorequired',
  ssoprovider = 'ssoprovider'
}


/**
 * Implemented Plugins
 */
export enum OrganisationPlugins {
  AFAS = 'AFAS',
  AFASInSite = 'AFASInSite',
  PinkwebAccordering = 'PinkwebAccordering',
  PinkwebDossier = 'PinkwebDossier',
  AuditCase = 'AuditCase',
  CaseWare = 'CaseWare',
  MAP = 'MAP',
  SharePoint = 'SharePoint',
  Hyarchis = 'Hyarchis',
  OneDrive = 'OneDrive',
  Teams = 'Teams',
  Visionplanner = 'Visionplanner',
  Nextens = 'Nextens',
}
/**
 * Plugins that are expected as Microsoft Plugins
 */
export const MicrosoftPlugins: any[] = [OrganisationPlugins.SharePoint, OrganisationPlugins.OneDrive, OrganisationPlugins.Teams];

export enum organisationClaims {
  AzureBlobStorage = "azureblobstorage",
  TwoFactorRequired = "twofactorrequired",
  SSORequired = "ssorequired",
  SSOProvider = "sso",
  GuestValidationMethod = "GuestValidationMethod"
}
export enum PluginSettings {
  EnablePlugin_SharePoint = 'EnablePlugin_SharePoint',
  EnablePlugin_Hyarchis = 'EnablePlugin_Hyarchis',
  EnablePlugin_OneDrive = 'EnablePlugin_OneDrive',
  EnablePlugin_Teams = 'EnablePlugin_Teams'
}
/**
 * SOME of these are ALSO Settings (WF), others are ONLY Permissions
 */
export enum PermissionsEnum {
  // allow switching of workflows
  Perm_WF_SignYourself = "Perm_WF_SignYourself",
  Perm_WF_SignatureRequest = "Perm_WF_SignatureRequest",
  Perm_WF_SecureFileSharing = "Perm_WF_SecureFileSharing",
  Perm_WF_IncomeTax = "Perm_WF_IncomeTax",
  Perm_WF_CorporateTax = "Perm_WF_CorporateTax",
  Perm_WF_VAT = "Perm_WF_VAT",
  Perm_WF_EUVAT = "Perm_WF_EUVAT",
  Perm_WF_WageTax = "Perm_WF_WageTax",
  Perm_WF_Filing = "Perm_WF_Filing",
  Perm_WF_FilingWithReport = "Perm_WF_FilingWithReport",
  Perm_WF_LinkingAndSigning = "Perm_WF_LinkingAndSigning",
  Perm_WF_SbrBank = "Perm_WF_SbrBank",
  Perm_WF_SbrBankWithReport = "Perm_WF_SbrBankWithReport",
  Perm_WF_NoabBankAudit = "Perm_WF_NoabBankAudit",
  Perm_WF_Wwft = "Perm_WF_Wwft",
  Perm_WF_FilingXBRI = "Perm_WF_FilingXBRI",
  Perm_WF_CleverbaseSignYourself = "Perm_WF_CleverbaseSignYourself",
  Perm_WF_CleverbaseRequest = "Perm_WF_CleverbaseRequest",

  // allow selection of Signature options
  Perm_Stamp = "Perm_Stamp",
  Perm_Drawing = "Perm_Drawing",
  Perm_Pictures = "Perm_Pictures",
  // Generic
  Perm_Two_Factor_Authentication = "Perm_Two_Factor_Authentication",
  Perm_Generate_DC = "Perm_Generate_DC",
  Perm_Force_AAD = "Perm_Force_AAD",
  // Allow enabling of intergrations/Services
  Perm_Afas = "Perm_Afas",
  Perm_Visionplanner = "Perm_Visionplanner",
  Perm_Nextens = "Perm_Nextens",
  Perm_Sharepoint = "Perm_Sharepoint",
  Perm_Teams = "Perm_Teams",
  Perm_Hyarchis = "Perm_Hyarchis",
  Perm_OneDrive = "Perm_OneDrive",
  Perm_SalesForce = "Perm_SalesForce",
  Perm_Simplicate = "Perm_Simplicate",
  Perm_MsDynamics = "Perm_MsDynamics",
  Perm_Digipoort = "Perm_Digipoort",
  Perm_SBRNexus = "Perm_SBRNexus",
  Perm_XbrlRenderService = "Perm_XbrlRenderService",
  Perm_AutoExport = "Perm_AutoExport",
  // Available Identity Providers
  Perm_IdP_Sms = "Perm_IdP_Sms",
  Perm_IdP_Whatsapp = "Perm_IdP_Whatsapp",
  Perm_IdP_IDIN = "Perm_IdP_IDIN",
  Perm_IdP_Cleverbase_Authentication = "Perm_IdP_Cleverbase_Authentication",
  Perm_IdP_Cleverbase_Identification = "Perm_IdP_Cleverbase_Identification",
}
export enum PermissionGroup {
  Setting = "Setting",
  WorkflowTypes = "WorkflowTypes",
  AvailableSignatureDisplayOptions = "AvailableSignatureDisplayOptions",
  TwoFactorAuthentication = "TwoFactorAuthentication",
  IdentificationProviders = "IdentificationProviders",
  AuditTrail = "AuditTrail",
  SSO = "SSO",
  PlatformAPIIntegrations = "PlatformAPIIntegrations",
  DocumentIntegrations = "DocumentIntegrations",
  AddressbookIntegrations = "AddressbookIntegrations",
  Services = "Services",
}
